export const TWIN_ICON = 'fa-regular fa-chart-network'
export const ASSET_ICON = 'mdi-circle-outline'
export const RISK_ICON = 'fa-solid fa-triangle-exclamation'
export const RISK_ICON_REG = 'fa-regular fa-triangle-exclamation'
export const WARNING_ICON = 'fa-solid fa-triangle-exclamation'
export const WARNING_ICON_OUTLINE = 'fa-regular fa-triangle-exclamation'
export const EDIT_ICON = 'fa-pen-to-square'
export const TRASH_ICON = 'fa-regular fa-trash-can'
